import { render, staticRenderFns } from "./BuyAddons.vue?vue&type=template&id=0c841016"
import script from "./BuyAddons.vue?vue&type=script&lang=js"
export * from "./BuyAddons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports